import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../../environments/environment';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { Subscription } from 'rxjs';
import { UploadService } from '../../../services/upload/upload.service';
import { DmsFile } from '../../../modal/upload/model/upload.model';

@Component({
  selector: 'app-pre-rfp-meeting',
  standalone: false,
  templateUrl: './pre-rfp-meeting.component.html',
  styleUrl: './pre-rfp-meeting.component.scss'
})
export class PreRfpMeetingComponent implements OnInit, AfterViewInit , OnDestroy {
  @Input() id: any
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  commentForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false
  @Input() stepDetails: any;
  @Input() schemeType: any;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  uploadedUrl: any;
  apiUrl = environment.APIUrl
 private subscriptions = new Subscription();
  userID: any;
  allDmsFiles: any[]=[];
  /** Mode of tender from draft-rfp API; hide vendor management when "Open Tender" or "Single Tender" */
  modeOfTender: string | null = null;

  constructor(private fb: FormBuilder, private config: PrimeNGConfig, 
    private uploadService: UploadService, private messageService: MessageService, 
    private api: ApiService, private route: ActivatedRoute) 
  { this.commentForm = this.fb.group({
        justification: ['', Validators.required],
      });
      const role = sessionStorage.getItem('user_role_id');
      this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      }
      //console.log(this.payload);
    });
    this.getRfpDetails();
  }

  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  expandedSections: { [key: string]: boolean } =
  {
    basicInfo: true,
    equipment: false,
    quantity: false,
    cost: false,
    detailedInfo: false,
    uploads: false,
    vendorTable: false
  };
   ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      // this.isEditorDisabled=true;
      // //console.log(this.isEditable , this.stepDetails)
      if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
      editorReady = false;
  rebuildEditor() {
  this.editorReady = false; // destroy
  setTimeout(() => {
    this.init = this.getTinyInit(); // refresh config
    this.editorReady = true; // recreate editor
  }, 0);
}
getTinyInit(): EditorComponent['init'] {
  return {
    readonly: this.isEditorDisabled
  };
}
  goToNextStep() {
    this.stepCompleted.emit();
  }
  rfpdata: any;
  getRfpDetails(): void {
    const proposalId = this.payload.proposal_id;
    const stepId = this.step.id;
    const normalizedScheme = this.schemeType?.toLowerCase().replace(/\s+/g, '');

    let apiUrl = '';

    if (['makei', 'makeii', 'makeiii'].includes(normalizedScheme)) {
      apiUrl = `/make1/pre-eol/?proposal_step=${stepId}&proposal_step__proposal=${proposalId}`;
    } else {
      apiUrl = `/revenue/pre-rfp/meeting/?proposal_step=${stepId}&proposal_step__proposal=${proposalId}`;
    }
    // Call API
    const sub =   this.api.getAPI(apiUrl).subscribe((res: any) => {
      // Revenue pre-rfp API returns { data: [...], vendor_data: {...}, mode_tendor: "..." }
      if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
        this.rfpdata = res.data[0];
      } else {
        this.rfpdata = res[0];
      }
      this.modeOfTender = res?.mode_tendor ??  null;
      console.log('this data is revenue RFP', this.rfpdata);
      const dmsFiles: DmsFile[] = this.rfpdata?.dms_files ?? [];
        this.allDmsFiles = dmsFiles;
      this.uploadedUrl = this.rfpdata?.mom || this.rfpdata?.file || null;
      this.commentForm.patchValue({
        justification: this.rfpdata?.justification || this.rfpdata?.paragraph || this.rfpdata?.comment || ''
        
      });
      const queryData = this.rfpdata?.prebid_query || this.rfpdata?.pre_eoi_query || this.rfpdata?.preeolmake_query || [];
     
    });
     this.subscriptions.add(sub);
  }

   /** True when vendor management (upload vendor files) should be hidden (Open Tender / Single Tender). */
  get hideVendorManagement(): boolean {
    const m = (this.modeOfTender || '').trim();
    return m === 'Open Tender' || m === 'Single Tender' || m === 'Open Tinder';
  }
  editForm() {
    this.commentForm.enable();
    this.messageService.add({ severity: 'info', summary: 'info', detail: 'Form is now editable.' });
  }

 

 
  onSubmit(): void {
    const formData = new FormData();
    if(this.schemeType == 'makeI'){
        formData.append('proposal_step', this.step.id);
        formData.append('justification', this.commentForm.get('justification')?.value || '');
    } if(this.schemeType == 'makeII' || this.schemeType == 'makeIII'){
        formData.append('proposal_step', this.step.id);
        formData.append('justification', this.commentForm.get('justification')?.value || '');
    }
    else{

    
    formData.append('proposal_step', this.step.id);
    formData.append('paragraph', this.commentForm.get('justification')?.value || '');

    
  }
    const normalizedScheme = this.schemeType?.toLowerCase().replace(/\s+/g, '');
    const isMakeScheme = ['makei', 'makeii', 'makeiii'].includes(normalizedScheme);

    // Determine base endpoint - Make I uses /make1/pre-eol/, others use existing endpoints
    const baseUrl = isMakeScheme ? '/make1/pre-eol/' : '/revenue/pre-rfp/meeting/';

    if (this.rfpdata?.id) {
      // Update existing RFP
  const sub =    this.api.putAPI(`${baseUrl}${this.rfpdata.id}/`, formData).subscribe({
        next: (res: any) => {
          // Check if response is successful - verify response has id or status indicates success
          const responseData = res?.data || res;
          const isSuccess = responseData && (
            responseData.id || 
            responseData.status === 1 || 
            responseData.status === '1' ||
            (responseData.justification !== undefined) // If justification exists, it's likely successful
          );
          
          if (isSuccess) {
            if (this.fileUpload) {
              this.fileUpload.clear();
            }
            this.getRfpDetails();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: responseData.message || res?.message || ' Data updated successfully'
            });
            // Emit routeConfig only after successful API response
           
          }
        },
        error: (err) => {
          console.error('Error updating pre-rfp-meeting:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to save data'
          });
        }
      });
       this.subscriptions.add(sub);
    } else {
      // Create new RFP
   const sub =   this.api.postAPI(baseUrl, formData).subscribe({
        next: (res: any) => {
          // Check if response is successful - verify response has id or status indicates success
          const responseData = res?.data || res;
          const isSuccess = responseData && (
            responseData.id || 
            responseData.status === 1 || 
            responseData.status === '1' ||
            (responseData.justification !== undefined) // If justification exists, it's likely successful
          );
          
          if (isSuccess) {
            if (this.fileUpload) {
              this.fileUpload.clear();
            }
            this.getRfpDetails();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: responseData.message || res?.message || 'Data uploaded successfully'
            });
            // Emit routeConfig only after successful API response
            
          }
        },
        error: (err) => {
          console.error('Error saving pre-rfp-meeting:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to save data'
          });
        }
      });
       this.subscriptions.add(sub);
    }
  }


  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Comments", value: this.commentForm.get('justification')?.value },

      ]
    };
    this.generatePDFEmitter.emit(payload);
  }



  get meetingTitle(): string {
  const normalized = this.schemeType?.toLowerCase().replace(/\s+/g, '');
  let title;
  if(normalized == 'makei' || normalized == 'makeii' || normalized == 'makeiii'){
    title ='Pre-EOI Meeting'
  }else if(normalized == 'rev' || normalized == 'idex'){
    title = 'RFP Vetting'
  }else{
    title ='Pre-RFP Meeting';
  }
  return title;
}

  saveRow(row: any) {
    console.log("Saved Row:", row);
    const normalizedScheme = this.schemeType?.toLowerCase().replace(/\s+/g, '');
    const isMakeScheme = ['makei', 'makeii', 'makeiii'].includes(normalizedScheme);
    
    // Determine base endpoint for query API
    const queryBaseUrl = isMakeScheme ? '/make1/pre-eol/query/' : '/revenue/pre-rfp/query/';
    
    let payload = {
      preeol: this.rfpdata.id,
      query: row.query,
      reply: row.reply,
      sequence: row.sequence
    }
    
    if (row.id) {
      const sub = this.api.putAPI(`${queryBaseUrl}${row.id}/`, payload).subscribe({
        next: (res: any) => {
          this.getRfpDetails();
          this.messageService.add({ 
            severity: 'success', 
            summary: 'Success', 
            detail: res.message || 'Query/Reply record updated successfully' 
          });
        },
        error: (err) => {
          console.error('Error updating query/reply:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to update query/reply'
          });
        }
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api.postAPI(queryBaseUrl, payload).subscribe({
        next: (res: any) => {
          this.getRfpDetails();
          this.messageService.add({ 
            severity: 'success', 
            summary: 'Success', 
            detail: res.message || 'Query/Reply record uploaded successfully' 
          });
        },
        error: (err) => {
          console.error('Error saving query/reply:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to save query/reply'
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }

  // Vendor Management Event Handlers
  onVendorAdded(event: any): void {
    console.log('Vendor added:', event);
  }

  onVendorUpdated(event: any): void {
    console.log('Vendor updated:', event);
  }

  onVendorDeleted(event: any): void {
    console.log('Vendor deleted:', event);
  }

  onFilesSubmitted(event: any): void {
    console.log('Files submitted:', event);
  }

}



